import { z } from "zod";
import type { PandadocDocumentStatus } from "@remi/enums/pandadoc-document-status";

export const PandadocDocumentStatusDisplayNames: Readonly<Record<PandadocDocumentStatus, string>> = {
  "document.uploaded": "Uploaded",
  "document.draft": "Draft",
  "document.sent": "Sent",
  "document.viewed": "Viewed",
  "document.completed": "Completed",
  "document.voided": "Voided",
  "document.declined": "Declined",
};

const PandadocStatusForResendValues = [
  "document.uploaded",
  "document.draft",
] as const satisfies PandadocDocumentStatus[];
export const PandadocStatusForResendSchema = z.enum(PandadocStatusForResendValues);

export const PandadocStatusAwaitingSignatureValues = [
  "document.sent",
  "document.viewed",
] as const satisfies PandadocDocumentStatus[];

export const PandadocDocumentFinalStatusValues = [
  "document.voided",
  "document.declined",
  "document.completed",
] as const satisfies PandadocDocumentStatus[];

// Not a subset of the Final values above to be folded into it: those mean "reached an end state",
// which includes a signature. These mean a signature can never arrive, so progress toward one is a
// false claim. Collapsing them would make a signed document read as dead.
export const PandadocDocumentUnsignableStatusValues = [
  "document.voided",
  "document.declined",
] as const satisfies PandadocDocumentStatus[];
